import styled from "styled-components";
import { Colors } from "@tvg/design-system";

export const ButtonContainer = styled.div<{
  isActive?: boolean;
  colors: Colors;
}>`
  display: flex;
  flex-shrink: 0;
  border-radius: 2px;
  background-color: ${({ colors, isActive }) =>
    isActive ? colors.blue_accent["200"] : "transparent"};
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
`;

export const ListItem = styled.li`
  display: flex;
  flex-direction: column;
`;

export const StyledButton = styled.button<{
  isActive: boolean;
  colors: Colors;
}>`
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
  height: 48px;
  padding: 0 12px;
  border: none;
  border-bottom: 1px solid ${({ colors }) => colors.blue["100"]};
  background-color: ${({ colors }) => colors.white["900"]};
`;
